import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IConstructionStatisticsRequestParams } from "../domain/IConstructionStatisticsRequestParams";
import { IValuationsInvestmentsStatistics } from "../domain/IValuationsInvestmentsStatistics";
import { StatisticsService } from "../services/statistics.service";

interface ValuationsStatisticsState {
  loading: boolean;
  statistics?: IValuationsInvestmentsStatistics;
  error: any;
}

const initialState: ValuationsStatisticsState = {
  loading: false,
  statistics: undefined,
  error: undefined,
};

export const getValuationsStatistics = createAsyncThunk(
  "Statistics/getValuationsStatistics",
  async (data?: IConstructionStatisticsRequestParams) => {
    try {
      const result = await StatisticsService.getValuationsStatistics(data);
      return result;
    } catch (err) {
      setError(err);
    }
  }
);

export const ValuationsStatisticsSlice = createSlice({
  name: "ValuationsStatistics",
  initialState: initialState,
  reducers: {
    setValuationsStatistics: (
      state,
      action: PayloadAction<IValuationsInvestmentsStatistics>
    ) => {
      state.statistics = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getValuationsStatistics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getValuationsStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.statistics = action.payload ? action.payload : undefined;
    });
    builder.addCase(getValuationsStatistics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const selectState = (state: RootState) => state.statistics.valuation;

export const { setError } = ValuationsStatisticsSlice.actions;

export default ValuationsStatisticsSlice.reducer;
